import { useEffect, useState } from "react";
import Link from "@/components/ui/RouterLink";
import { Menu, MessageSquare } from "lucide-react";
import { Logo } from "./Logo";
import { MegaMenu } from "./MegaMenu";
import { MobileNav } from "./MobileNav";
import { primaryNav } from "@/config/navigation";
import { whmcs } from "@/config/whmcs";
import { analytics } from "@/lib/analytics";
import { cn } from "@/lib/utils";

export function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    function onScroll() {
      setScrolled(window.scrollY > 24);
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={cn(
        "sticky top-0 z-50 transition-colors duration-300",
        scrolled ? "border-b border-border bg-navy/90 backdrop-blur-md" : "bg-transparent"
      )}
    >
      <div className="mx-auto flex h-[72px] max-w-7xl items-center justify-between px-5 lg:px-8">
        <Logo />

        <nav className="hidden items-center gap-1 md:flex">
          {primaryNav.map((item) =>
            "hasMegaMenu" in item && item.hasMegaMenu ? (
              <div key={item.label} className="group relative">
                <Link
                  href={item.href}
                  className="focus-ring rounded-md px-4 py-2 text-sm font-medium text-text-secondary transition hover:text-text-primary"
                >
                  {item.label}
                </Link>
                <div className="invisible absolute left-1/2 -translate-x-1/2 opacity-0 transition-all duration-150 group-hover:visible group-hover:opacity-100 group-focus-within:visible group-focus-within:opacity-100">
                  <MegaMenu />
                </div>
              </div>
            ) : (
              <Link
                key={item.label}
                href={item.href}
                className="focus-ring rounded-md px-4 py-2 text-sm font-medium text-text-secondary transition hover:text-text-primary"
              >
                {item.label}
              </Link>
            )
          )}
        </nav>

        <div className="hidden items-center gap-3 md:flex">
          <a
            href={whmcs.loginUrl}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => analytics.track("client_login_click")}
            className="focus-ring rounded-full border border-border px-4 py-2 text-sm font-medium text-text-primary transition hover:border-cyan/50"
          >
            Client Login
          </a>
          <Link
            href="/contact"
            className="focus-ring inline-flex items-center gap-1.5 rounded-full px-4 py-2 text-sm font-medium text-text-secondary hover:text-text-primary"
          >
            <MessageSquare className="h-3.5 w-3.5" /> Talk to an Expert
          </Link>
          <a
            href={whmcs.storeUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="focus-ring rounded-full bg-gradient-brand px-5 py-2.5 text-sm font-medium text-white transition hover:brightness-110"
          >
            Get Started
          </a>
        </div>

        <button
          className="focus-ring text-text-primary md:hidden"
          aria-label="Open menu"
          onClick={() => setMobileOpen(true)}
        >
          <Menu className="h-6 w-6" />
        </button>
      </div>

      <MobileNav open={mobileOpen} onClose={() => setMobileOpen(false)} />
    </header>
  );
}
